export default "__VITE_ASSET__3565d316__"